import React from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import AppButton, { AppButtonProps } from 'shared/AppButton'
import { CAPTCHA_V3_ENABLE, CAPTCHA_V3_KEY } from 'api/config'
import {
  isReCaptchaFeatureEnabled,
  reCaptchaVersion,
  reCaptchaFeature,
} from './ParkerLinkReCaptcha'

export interface AppButtonWithReCaptchaProps extends AppButtonProps {
  reCaptchaFeature: reCaptchaFeature
  /** Will return null if feature/recaptcha is not enabled */
  onReCaptchaFinished: (
    recaptchaToken?: string,
    version?: reCaptchaVersion
  ) => void
}

export const AppButtonWithReCaptcha: React.FC<AppButtonWithReCaptchaProps> = ({
  reCaptchaFeature,
  onReCaptchaFinished,
  ...props
}) => {
  const { executeRecaptcha } = useGoogleReCaptcha()

  const runReCaptcha = () => {
    if (!CAPTCHA_V3_ENABLE || !isReCaptchaFeatureEnabled(reCaptchaFeature)) {
      onReCaptchaFinished(null, reCaptchaVersion.v3)
      return
    }

    if (!CAPTCHA_V3_KEY || !executeRecaptcha) {
      console.warn('reCAPTCHA v3 is not ready.')
      setTimeout(runReCaptcha, 1000)
      return
    }

    executeRecaptcha('verify_user').then(reCaptchaToken => {
      onReCaptchaFinished(reCaptchaToken, reCaptchaVersion.v3)
    })
  }

  return <AppButton onClick={() => runReCaptcha()} {...props} />
}
